import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import './../index.css';

/**
 * Component that immediately redirects to Cognito hosted UI
 */
const RedirectToHostedUI = () => {
  const [hasRedirected, setHasRedirected] = useState(false);
  
  useEffect(() => {
    // Only redirect once to prevent loops
    if (!hasRedirected) {
      setHasRedirected(true);
      
      // Check if we're already in the middle of an auth flow
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('code')) {
        // Only redirect if we're not already in an auth flow
        Auth.federatedSignIn();
      }
    }
  }, [hasRedirected]);

  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default RedirectToHostedUI;